export const ROLE_ADMIN = 'ROLE_ADMIN';
export const ROLE_USER = 'ROLE_USER';
export const ROLE_VIEWER = 'ROLE_VIEWER';
export const ROLE_PAYER = 'ROLE_PAYER';
export const ROLE_ANONYMOUS = 'ROLE_ANONYMOUS';
